import { find } from 'lodash';
import type { AmlCallView, PhoneCallView } from './types';

export const getRelatedCall = (
    phoneNumbers: (number | undefined)[] = [],
    phoneCalls: PhoneCallView[] | AmlCallView[]
): PhoneCallView | AmlCallView | undefined => {
    if (!phoneNumbers.length) return;

    for (let i = 0; i < phoneNumbers.length; i++) {
        if (!phoneNumbers[i]) {
            continue;
        }
        const relatedCall = find(phoneCalls, { phoneNumberId: phoneNumbers[i] });

        if (relatedCall) {
            return relatedCall as PhoneCallView | AmlCallView;
        }
    }
};
